import { useQuery } from '@tanstack/react-query';
import tagsApi from '@/features/dashboard/tags/api/tagsApi.ts';
import { tagsApiQueryKeys } from '@/features/dashboard/tags/api/tagsApi.queryKeys.ts';

const useGetTags = () => {
  return useQuery({
    queryKey: tagsApiQueryKeys.all(),
    queryFn: tagsApi.getAll,
    staleTime: 1000 * 60,
  });
};

export default useGetTags;
